/* eslint-disable import/no-anonymous-default-export */
export default {
  baseStyle: {
    container: {
      boxShadow: "0px 2px 25px rgba(0, 0, 0, 0.1)",
    },
  },
};
